// extracted by mini-css-extract-plugin
export var button = "price-buttons-filters-module--button--Z79Vn";
export var buttonSelected = "price-buttons-filters-module--buttonSelected--MCDcJ";
export var buttons = "price-buttons-filters-module--buttons--DWnSl";
export var heading = "price-buttons-filters-module--heading--3DUpo";
export var wrap = "price-buttons-filters-module--wrap--6xEv9";